"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const protocol_1 = require("@/rpc/lib/protocol");
const codec_1 = tslib_1.__importDefault(require("@/assets/config/codec"));
const error_message_1 = tslib_1.__importDefault(require("@/assets/config/error_message"));
var Encoding = protocol_1.protocol.Encoding;
var DefaultResponse = protocol_1.protocol.DefaultResponse;
var GetTcpPoseRequest = protocol_1.protocol.GetTcpPoseRequest;
var InverseKinematicRequest = protocol_1.protocol.InverseKinematicRequest;
var InverseKinematicResponse = protocol_1.protocol.InverseKinematicResponse;
var GetTcpPoseResponse = protocol_1.protocol.GetTcpPoseResponse;
var GetIOInputStateRequest = protocol_1.protocol.GetIOInputStateRequest;
var GetIOOutputStateRequest = protocol_1.protocol.GetIOOutputStateRequest;
var GetIOStateResponse = protocol_1.protocol.GetIOStateResponse;
var GetRobotStateRequest = protocol_1.protocol.GetRobotStateRequest;
var GetRobotStateResponse = protocol_1.protocol.GetRobotStateResponse;
var GetFileRunningStateRequest = protocol_1.protocol.GetFileRunningStateRequest;
var GetFileRunningStateResponse = protocol_1.protocol.GetFileRunningStateResponse;
var GetRobotSpeedRequest = protocol_1.protocol.GetRobotSpeedRequest;
var GetRobotSpeedResponse = protocol_1.protocol.GetRobotSpeedResponse;
var GetJointsRequest = protocol_1.protocol.GetJointsRequest;
var GetJointsResponse = protocol_1.protocol.GetJointsResponse;
var GetMotorStatusResponse = protocol_1.protocol.GetMotorStatusResponse;
var GetMotorStatusRequest = protocol_1.protocol.GetMotorStatusRequest;
var requestMap = protocol_1.protocol.requestMap;
let reqResMap = new Map();
function getAllProperties(obj) {
    let properties = [];
    for (let prop in obj) {
        properties.push(prop);
    }
    const prototype = Object.getPrototypeOf(obj);
    if (prototype) {
        properties = properties.concat(getAllProperties(prototype));
    }
    return properties;
}
class Codec {
    getSocketCfgByRequest(req, brand) {
        var _a;
        const cfg = (_a = codec_1.default[brand]) === null || _a === void 0 ? void 0 : _a.socket;
        if (!cfg) {
            throw new Error('config not found');
        }
        let className = requestMap.get(req.constructor.name);
        if (!className) {
            throw new Error('class name not found');
        }
        let props = getAllProperties(req);
        let res = { cmd: cfg[className].request, resCfg: cfg[className].response };
        props.forEach(prop => {
            res.cmd = res.cmd.replace(`\${${prop}}`, JSON.stringify(req[prop]));
        });
        return res;
    }
    getHttpCfgByRequest(req, brand) {
        var _a;
        const cfg = (_a = codec_1.default[brand]) === null || _a === void 0 ? void 0 : _a.http;
        if (cfg.extends && cfg.extends.target) {
            let { data, url, method } = cfg.extends;
            let res = {
                url,
                method,
                data: {}
            };
            res.data[data] = cfg.extends.target === 'socket' ? this.getSocketCfgByRequest(req, brand).cmd : '';
            return res;
        }
    }
}
class EliteSocketCodec extends Codec {
    encode(req) {
        reqResMap.set(req.id, req);
        let res = this.getSocketCfgByRequest(req, 'elite').cmd;
        return res;
    }
    decode(data) {
        let p = "result\":\"{";
        if (data.indexOf(p) !== -1) {
            let count = 1;
            let endIndex = -1;
            for (let i = data.indexOf("result\":\"{") + p.length; i < data.length; i++) {
                if (count === 0) {
                    endIndex = i;
                    break;
                }
                if (data.charAt(i) === '{') {
                    count++;
                    continue;
                }
                else if (data.charAt(i) === '}') {
                    count--;
                    continue;
                }
            }
            let newData = data.substring(0, endIndex);
            newData += data.substring(endIndex + 1, data.length);
            data = newData.replace("result\":\"{", "result\":{");
        }
        let resData = JSON.parse(data);
        if (typeof resData.result === 'string') {
            resData.result = JSON.parse(resData.result);
        }
        else if (typeof resData.error === 'string') {
            resData.error = JSON.parse(resData.error);
        }
        let reqId = String(resData[codec_1.default['elite'].socket.id]);
        let req = reqResMap.get(reqId);
        reqResMap.delete(reqId);
        let cfg = this.getSocketCfgByRequest(req, 'elite').resCfg;
        const getProp = (data, propsStr) => {
            let props = propsStr.split('.');
            let resData = data;
            for (let i = 0; i < props.length; i++) {
                resData = resData[props[i]];
                if (resData == null) {
                    return resData;
                }
            }
            return resData;
        };
        let res;
        if (req instanceof GetTcpPoseRequest) {
            res = new GetTcpPoseResponse(req.id, true, getProp(resData, cfg.pose));
        }
        else if (req instanceof GetJointsRequest) {
            res = new GetJointsResponse(req.id, true, getProp(resData, cfg.joints));
        }
        else if (req instanceof InverseKinematicRequest) {
            res = new InverseKinematicResponse(req.id, true, getProp(resData, cfg.pos));
        }
        else if ((req instanceof GetIOInputStateRequest) || (req instanceof GetIOOutputStateRequest)) {
            res = new GetIOStateResponse(req.id, true, getProp(resData, cfg.status));
        }
        else if (req instanceof GetRobotStateRequest) {
            let state = getProp(resData, cfg.state);
            let stateStr = 'stop';
            switch (state) {
                case 0:
                    stateStr = 'stop';
                    break;
                case 1:
                    stateStr = 'paused';
                    break;
                case 2:
                    stateStr = 'egcStop';
                    break;
                case 3:
                    stateStr = 'running';
                    break;
                case 4:
                    stateStr = 'error';
                    break;
                case 5:
                    stateStr = 'crash';
                    break;
            }
            res = new GetRobotStateResponse(req.id, true, stateStr);
        }
        else if (req instanceof GetFileRunningStateRequest) {
            let state = getProp(resData, cfg.state);
            let stateStr = 'stop';
            switch (state) {
                case 0:
                    stateStr = 'stop';
                    break;
                case 1:
                    stateStr = 'paused';
                    break;
                case 2:
                    stateStr = 'egcStop';
                    break;
                case 3:
                    stateStr = 'running';
                    break;
                case 4:
                    stateStr = 'error';
                    break;
            }
            res = new GetFileRunningStateResponse(req.id, true, stateStr);
        }
        else if (req instanceof GetRobotSpeedRequest) {
            let speed = getProp(resData, cfg.speed);
            res = new GetRobotSpeedResponse(req.id, true, speed);
        }
        else if (req instanceof GetMotorStatusRequest) {
            let state = getProp(resData, cfg.state) ? 'synchronous' : 'asynchronous';
            res = new GetMotorStatusResponse(req.id, true, state);
        }
        else {
            res = new DefaultResponse(req.id, false);
        }
        res.msg = getProp(resData, cfg.msg) || res.msg;
        if (res.msg) {
            for (let i = 0; i < error_message_1.default.length; i++) {
                if (error_message_1.default[i].sysErr['elite'] === res.msg) {
                    res.msg = `${error_message_1.default[i].tip}(${error_message_1.default[i].errCode})`;
                }
            }
        }
        res.success = getProp(resData, cfg.success) != null;
        return res;
    }
}
class EliteHttpCodec extends Codec {
    decode(resp) {
        if (codec_1.default.elite.http.extends) {
            let extendsTarget = codec_1.default.elite.http.extends.target;
            if (extendsTarget === 'socket') {
                return Encoding['socket.elite'].decode(resp);
            }
        }
        throw new Error('please decode http config');
    }
    encode(req) {
        reqResMap.set(req.id, req);
        return this.getHttpCfgByRequest(req, 'elite');
    }
}
class SftpCodec {
    encode(req) {
        throw new Error('impl encode!');
    }
    decode(resp) {
        let res = JSON.parse(resp);
        return new DefaultResponse(res.path, res.success, res.msg);
    }
}
Encoding.register('http.elite', new EliteHttpCodec());
Encoding.register('socket.elite', new EliteSocketCodec());
Encoding.register('sftp', new SftpCodec());
